//	Dependencies imported for this theme
import imagesLoaded from 'imagesloaded'; // Quiet
import Splide from '@splidejs/splide'; // Quiet

import { gsap } from "gsap"; // Quiet
import { ScrollTrigger } from "gsap/ScrollTrigger"; // Quiet

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {

	/**
	 * Detects whether the user is on a mobile or desktop device.
	 * This is based on viewport width or specific device characteristics.
	 *
	 * @returns {string} 'mobile' or 'desktop' depending on the detected device.
	 */
	function isDesktop() {
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

		if (isMobile) {
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Scroll lock manager
	 * Determines if the no-scroll class should be added or removed when toggling elements
	 * like the sidemenu or modals. This prevents conflicts when there are
	 * multiple elements that require scroll locking (e.g., sidemenu, modals).
	 */
	const ScrollLock = {
		locks: new Set(),

		log(action, source) {
			console.log(
				`%c[ScrollLock] ${action}: %c${source}`,
				"color: #0af; font-weight: bold;",
				"color: #999;",
				"→ Active locks:",
				Array.from(this.locks)
			);
		},

		lock(source, { scrim = false } = {}) {
			this.locks.add(source);
			document.body.classList.add("no-scroll");
			if (scrim) {
				document.body.classList.add("with-scrim");
			}
			this.log("LOCK", source);
		},

		unlock(source) {
			this.locks.delete(source);
			if (this.locks.size === 0) {
				document.body.classList.remove("no-scroll");
				document.body.classList.remove("with-scrim");
			}
			this.log("UNLOCK", source);
		}
	};

	/**
	 * Implements smooth scrolling for elements with the `.js-scroll` class.
	 * When clicked, the element smoothly scrolls to the target specified in the `href` attribute.
	 *
	 * @class .js-scroll
	 * @param {string} href - The target element to scroll to (must be a valid ID selector).
	 * @param {number} data-scroll-offset - An optional offset (in pixels) to adjust the scroll position.
	 */

	document.addEventListener("click", (event) => {
		const element = event.target.closest(".js-scroll"); // Ensure it's a link with the class js-scroll
		if (!element) return;

		event.preventDefault();

		let targetSelector = element.getAttribute("href");

		if (!targetSelector) return; // Ensure there's a valid href

		let scrollTarget = document.querySelector(targetSelector); // Selects first matching element

		if (!scrollTarget) {
			console.warn("No element found for:", targetSelector);
			return;
		}

		let targetPos = scrollTarget.getBoundingClientRect().top + window.scrollY; // Get absolute position
		let targetOffset =
			parseInt(element.getAttribute("data-scroll-offset"), 10) || 0; // Optional offset

		scrollTarget.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});

		// Optional: Update URL without affecting history
		history.replaceState(null, null, targetSelector);
	});


	/**
	 * Toggles (side menu, drawers, etc.)
	 * Trigger: .js-toggle with href="#target" or ".target"
	 */
	const jsToggle = document.querySelectorAll(".js-toggle");

	if (jsToggle.length > 0) {
		jsToggle.forEach(function (element) {
			element.addEventListener("click", function (event) {
				event.preventDefault();

				const targetSelector = element.getAttribute("href");
				const toggleTarget   = document.querySelector(targetSelector);

				if (!toggleTarget) {
					console.warn(`Target not found for ${targetSelector}`);
					return;
				}

				const isOpening = !toggleTarget.classList.contains("active");

				// Toggle classes
				this.classList.toggle("active");
				toggleTarget.classList.toggle("active");

				// Scroll lock if trigger has stop-scroll
				if (this.classList.contains("stop-scroll")) {
					const lockId = targetSelector;
					const wantsScrim = this.classList.contains("add-scrim");

					if (isOpening) {
						ScrollLock.lock(lockId, { scrim: wantsScrim });
					} else {
						ScrollLock.unlock(lockId);
					}
				}
			});
		});
	}

	/**
	 *	The sidemenu and commentsection can also be closed by clicking on the content area
	 */
	const contentClose = document.getElementById("container");

	if (contentClose) {
		contentClose.addEventListener("click", function (event) {
			if (event.target == contentClose) {
				let navToggles 		= document.querySelectorAll(".js-nav-toggle.active"),
					fullScreenMenu	= document.querySelector(".js-fullscreen-menu.active");

				navToggles.forEach(function (element) {
					element.classList.remove("active");
				});

				fullScreenMenu.classList.remove("active");
				document.body.classList.remove("no-scroll");
			}
		});
	}

	/**
	 *	Wordpress submenu's
	 *	When navigation items with submenu's are clicked, add a class
	 *	to the anchor and the adjecent sub-menu
	 */
	if (typeof wp !== "undefined") {
		const menuWithChild = document.querySelectorAll(".menu-item-has-children > a");

		menuWithChild.forEach(function (element, index) {
			element.addEventListener("click", function (event) {
				event.preventDefault();
				this.classList.toggle("active");
				this.nextElementSibling.classList.toggle("active");
			});
		});
	}

	/**
	 *	Wordpress submenu's with added ghost links
	 *	When navigation items with submenu's are clicked, add a class 
	 *	to the anchor and the adjecent sub-menu, also add the parent-item to the
	 *	submenu since the parent toggles the submenu and is not in itself clickable
	 *
	*/
	if ( typeof wp !== "undefined" && !isDesktop() ) {
	
		const menuHeaderWithChild = document.querySelectorAll('.menu-item-has-children');

		if ( menuHeaderWithChild.length > 0 ) {
			
			menuHeaderWithChild.forEach( function(element, index) {

				let	  parentLink	= element.querySelector(':scope > a')
					, subMenu		= element.querySelector('.sub-menu');

				if ( parentLink && subMenu) {

					const clonedLink = parentLink.cloneNode(true);
					const newListItem = document.createElement('li');

					newListItem.className = 'cloned-link';
					newListItem.appendChild( clonedLink );

					subMenu.prepend( newListItem );

				}

				parentLink.addEventListener('click', function(event) {

					event.preventDefault();

					this.classList.toggle('active');
					this.nextElementSibling.classList.toggle('active');
				});

			});
		}
	}
	

	/**
	 * Sticky header with conceal/reveal on scroll
	 * Works smoothly on desktop + iOS Safari
	 */

	const stickyHeader = document.querySelector(".js-sticky");

	if (stickyHeader) {
		let sticky         = stickyHeader.offsetTop;
		let lastScrollTop  = 0;
		let scrollTimeout;
		const threshold    = 10; // minimum scroll delta before toggling

		// Debounce utility
		function debounce(func, delay) {
			let timeout;
			return function () {
				clearTimeout(timeout);
				timeout = setTimeout(func, delay);
			};
		}

		// Main scroll handler
		const handleScroll = debounce(function () {
			const currentScrollPos = window.pageYOffset;

			// Add/remove the 'stuck' class
			stickyHeader.classList.toggle("stuck", currentScrollPos > sticky);

			// Conceal/reveal only if scrolled more than threshold
			if (currentScrollPos < lastScrollTop - threshold) {
				stickyHeader.classList.remove("concealed");
			} else if (currentScrollPos > lastScrollTop + threshold) {
				stickyHeader.classList.add("concealed");
			}

			lastScrollTop = currentScrollPos;
		}, 10);

		// Scroll listener
		window.addEventListener("scroll", () => {
			requestAnimationFrame(handleScroll);

			// Reset when scrolling stops (fix for iOS momentum scroll)
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				const currentScrollPos = window.pageYOffset;
				if (currentScrollPos <= lastScrollTop + threshold) {
					stickyHeader.classList.remove("concealed");
				}
			}, 150); // tweak if needed
		});

		// Extra safeguard for iOS: always reveal when touch ends
		window.addEventListener("touchend", () => {
			stickyHeader.classList.remove("concealed");
		});
	}


	/**
	 * Fancy input fields that display placeholder text when hovered or focused.
	 * The placeholder text behaves like a label and disappears when the input is interacted with.
	 */
	const fancyInputs = document.querySelectorAll(".fancy-input");

	if (fancyInputs.length > 0) {
		fancyInputs.forEach(function (element) {
			const fancyInput 	= element.querySelector("input, textarea");
			const label 		= element.querySelector("label");

			if (fancyInput) {
			const hasPlaceholder = fancyInput.hasAttribute("placeholder");

			// Add the 'js-fancy-input' and 'js-fancy-input-style' classes
			element.classList.add("js-fancy-input", "js-fancy-input-style");

			// If a placeholder is present, concatenate it with the label text
			if (hasPlaceholder) {
				label.innerHTML = `${label.innerHTML} ${fancyInput.getAttribute("placeholder")}`;
				fancyInput.setAttribute("placeholder", ""); // Clear the placeholder
			}

			// Move label when focused by adding the class to the wrapper
			fancyInput.addEventListener("focus", function () {
				if (hasPlaceholder) {
				element.classList.add("js-fancy-input-out");
				} else {
				element.classList.add("js-fancy-input-out");
				}
			});

			// Move label back when blurred, but only if the input is empty
			fancyInput.addEventListener("blur", function () {
				if (fancyInput.value === "") {
				element.classList.remove("js-fancy-input-out");
				}
			});

			// If the input already has a value, move the label up
			if (fancyInput.value !== "" && !hasPlaceholder) {
				element.classList.add("js-fancy-input-out");
			}
			}
		});
	}

	/**
	 * Modal windows
	 * An ACF powered Gutenberg block
	 */
	const modalTriggers = document.querySelectorAll(".js-modal-trigger");

	if (modalTriggers.length > 0) {
		modalTriggers.forEach((trigger) => {
			
			const modal = document.querySelector(trigger.getAttribute("href"));

			if (modal) {

				const closeButtons = modal.querySelectorAll(".js-modal-close");
				const modalWrapper = modal.closest(".modal--wrapper");

				// Open modal
				trigger.addEventListener("click", function (event) {

					event.preventDefault();
					modal.classList.add("active");
					document.body.classList.add("no-scroll");
				});

				// Close modal when clicking close button
				closeButtons.forEach((button) => {
					button.addEventListener("click", function (event) {
						event.preventDefault();
						closeModal();
					});
				});

				// Close modal when clicking outside modal content
				modal.addEventListener("click", function (event) {
					if (!event.target.closest(".modal--inner")) {
						closeModal();
					}
				});

				// Close modal function
				function closeModal() {
					modal.classList.remove("active");
					document.body.classList.remove("no-scroll");

					// Stop any iframe video playback by resetting the src
					const iframe = modal.querySelector("iframe");
					if (iframe) {
						const src = iframe.src;
						iframe.src = ""; // Force stop
						iframe.src = src; // Reset to allow replay
					}
				}
			}
		});
	}


	/**
	 * GSAP ScrollTrigger
	 * Used for changing styles when scrolling over darker elements
	 *
	 * @class .js-inview - These elements will change their styles when scrolling over them
	 * @param {string} is-dark - the class to add when the element is dark
	 */
	const handleDarkClass = (element, add) => {
		if (add) {
			if (element.classList.contains("is-dark")) {
				document.body.classList.add("is-dark");
			}
		} else {
			document.body.classList.remove("is-dark");
		}
	};
	
	const scrollTriggers = document.querySelectorAll(".js-inview");
	
	if (scrollTriggers.length > 0) {
		scrollTriggers.forEach(function (element) {
			ScrollTrigger.create({
				trigger: element,
				start: "top+=59 center",
				end: "bottom center",
				onEnter: () => {
					handleDarkClass(element, true);
				},
				onEnterBack: () => {
					handleDarkClass(element, true);
				},
				onLeave: () => {
					handleDarkClass(element, false);
				},
				onLeaveBack: () => {
					handleDarkClass(element, false);
				},
				toggleClass: "is-active"
			});
		});
	}


	/**
	 *	Slideshows for features section
	*/
	const	  appFeatures = document.querySelectorAll('.js-features');

	if ( appFeatures.length > 0 ) {
			
		appFeatures.forEach( function(element, index) {

			let	  slideShow		= element.querySelector('.splide')
				, slideShowTabs	= element.querySelectorAll('.js-slideshow-tabs > li')
				, tabLinks		= element.querySelectorAll('.js-slideshow-tabs a');

			if ( slideShow ) {

				/**
				 * Initiate the slideshow with Splide
				*/
				var featuresSlideShow = new Splide( slideShow, {
					  type			: 'loop'
					, perPage		: 1
					, autoplay		: false
					, interval		: 5000
					, speed			: 400
				} ).mount();

				/**
				 * Let's update the slideshow tabs according to the active slide index
				*/
				featuresSlideShow.on('move', function() {

					let	slideIndex = featuresSlideShow.index;

					slideShowTabs.forEach( function(element, index) {
						if ( index !== slideIndex ) {
							element.classList.remove('active');
						} else {
							element.classList.add('active');
						}
						
					});

				});

				/**
				 * Vice versa, a click on a tab should move the slideshow to the corresponding slide
				*/
				tabLinks.forEach(function(element) {
					element.addEventListener('click', function(event) {
						event.preventDefault();

						const targetIndex = parseInt(element.getAttribute('data-slide-target'), 10);

						if (featuresSlideShow.index !== targetIndex) {
							featuresSlideShow.go(targetIndex);
						}
					});
				});
			}
			
		});
	}


	/**
	 *	Slideshows for Testimonials
	*/
	const	  testimonials = document.querySelectorAll('.js-testimonials');

	if ( testimonials.length > 0 ) {
			
		testimonials.forEach( function(element, index) {

			let	  slideShow		= element.querySelector('.splide');

			if ( slideShow ) {
				/**
				 * Initiate the slideshow with Splide
				*/
				var testimonialsSlideShow = new Splide( slideShow, {
					  type			: 'loop'
					, perPage		: 1
					, autoplay		: true
					, interval		: 5000
					, speed			: 1000
					, arrows		: true
					, pagination	: true
//					, autoHeight	: true
				} ).mount();
			}
			
		});
	}


	/**
	 *	Slideshows for App Screenshots
	*/
	const	  appSlideshow = document.querySelectorAll('.js-app-screens');

	if ( appSlideshow.lengt > 0 ) {
			
		appSlideshow.forEach( function(element, index) {

			let	  slideShow		= element.querySelector('.splide');

			if ( slideShow ) {
				/**
				 * Initiate the slideshow with Splide
				*/
				var postSliderSlideShow = new Splide( slideShow, {
					  type			: 'loop'
					, perPage		: 1
					, autoplay		: true
					, interval		: 5000
					, speed			: 250
					, arrows		: false
	//				, pagination	: true
				} ).mount();
			}
			
		});
	}

	/**
	 *	Post-slider: a custom Gutenberg block to create sldieshow
	*/
	const	  postSlideshow = document.querySelectorAll('.post-slider');

	if ( postSlideshow.length > 0 ) {
			
		postSlideshow.forEach( function(element, index) {

			let	  slideShow		= element.querySelector('.splide');

			if ( slideShow ) {
				/**
				 * Initiate the slideshow with Splide
				*/
				var postSliderSlideShow = new Splide( slideShow, {
					  type			: 'loop'
					, perPage		: 3
					, breakpoints	: {
						1360	: { perPage: 2 },	// sCSS var $breakpoints lg
						960		: { perPage: 1 } 	// sCSS var $breakpoints sm
					}
					, autoplay		: true
					, interval		: 5000
					, speed			: 250
					// , autoWidth		: true
					// , autoHeight	: true
					, gap			: '1.75rem'
					, arrows		: true
					, pagination	: false
				} ).mount();
			}
			
		});
	}

	/**
	 * Let's add a class to the first and last block in the post--content section
	 */
	document.querySelectorAll('.post--content > .inner').forEach(post => {
		const firstChild 	= post.firstElementChild;
		const lastChild 	= post.lastElementChild;

		if (firstChild ) {
			firstChild.classList.add('first-block');
		}
		if (lastChild ) {
			lastChild.classList.add('last-block');
		}
	});

});	// DOMContent loaded
